import { render, staticRenderFns } from "./GraphicsChart.vue?vue&type=template&id=873d0f06&scoped=true&"
import script from "./GraphicsChart.vue?vue&type=script&lang=js&"
export * from "./GraphicsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873d0f06",
  null
  
)

export default component.exports